import UpdateEmailComponent from "../../components/Auth/UpdateEmailComponent";
const UpdateEmailPage = () => {
  return (
    <>
      <UpdateEmailComponent />
    </>
  );
};
export default UpdateEmailPage;
